import React from "react";
import CareerSkillsSection from "../Shared/CareerSkillsSection";

const ITCareerSkillsSection = ({ componentData }) => {
  // Parse content into paragraphs (split by double line breaks). Strip the
  // legacy "Discover our…" call-to-action wherever it appears so the section
  // flows cleanly into the new Course Duration / Benefits sections below.
  const paragraphs = (componentData?.content
    ? componentData.content.split(/\n\n+/).filter(p => p.trim())
    : [
        `Information Technology is one of the most in-demand fields in today's world. At JRIIT, our IT program equips you with practical, hands-on skills in computer hardware, software, networking, cybersecurity, database management, and web development. Whether you are starting from scratch or building on existing knowledge, our program gives you a structured, industry-recognized pathway to a successful tech career right here in Tanzania and beyond.`,
        `Why JRIIT? We emphasize hands-on learning rather than traditional letter grades. In every course, you will receive detailed feedback on your technical strengths and areas for improvement, giving you a more complete picture of your growth.`,
      ]
  ).filter((p) => !/^\s*discover our\b/i.test(p));

  const title = componentData?.title || "TECH-READY SKILLS? CHECK.";

  return (
    <CareerSkillsSection
      title={title}
      subtitleLine={true}
      paragraphs={paragraphs}
    />
  );
};

export default ITCareerSkillsSection;
